import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FileText, FileSpreadsheet } from 'lucide-react';
import ConsolidatedPL from './ConsolidatedPL';
import FinancialReports from './FinancialReports';

const TABS = [
  { id: 'pl', label: 'Consolidated P&L', icon: FileSpreadsheet, Comp: ConsolidatedPL },
  { id: 'reports', label: 'Financial Reports', icon: FileText, Comp: FinancialReports },
];

export default function Financials() {
  const [params, setParams] = useSearchParams();
  const initial = TABS.find(t => t.id === params.get('tab'))?.id || 'pl';
  const [tab, setTab] = useState(initial);
  const Active = TABS.find(t => t.id === tab)?.Comp || ConsolidatedPL;
  const select = (id) => { setTab(id); setParams(id === 'pl' ? {} : { tab: id }, { replace: true }); };

  return (
    <div className="space-y-4" data-testid="financials-page">
      <div>
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#F26522] font-semibold">Performance · Financials</p>
        <h1 className="text-2xl sm:text-3xl font-black text-[#3E2418] tracking-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>Financials</h1>
      </div>
      <div className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1 sticky top-0 z-10" data-testid="financials-tabs">
        {TABS.map(t => {
          const Icon = t.icon;
          const active = t.id === tab;
          return (
            <button
              key={t.id}
              onClick={() => select(t.id)}
              data-testid={`financials-tab-${t.id}`}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-semibold transition-colors ${active ? 'bg-[#F26522] text-white' : 'bg-white text-slate-600 border border-[#E5E1DA] hover:bg-[#FAF8F5]'}`}
            >
              <Icon className="w-4 h-4" />{t.label}
            </button>
          );
        })}
      </div>
      <div data-testid="financials-panel">
        <Active />
      </div>
    </div>
  );
}
